module.exports = __webpack_public_path__ + "media/src/images/icons/credit_cards/diners-16d7fd92825dd8bbd0c7d6ea85382765.gif";